import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  description: {
    id: 'frontbucket.account.settings.gpgKeys.description',
    description: 'Main description message',
    defaultMessage:
      'Use GPG keys to allow verification of your commit signatures. {learnMoreLink}',
  },
  noKeysAdded: {
    id: 'frontbucket.account.settings.gpgKeys.noKeysAdded',
    description: 'No keys added message',
    defaultMessage: 'There are no keys added.',
  },
  learnMoreLinkLabel: {
    id: 'frontbucket.account.settings.gpgKeys.learnMoreLinkLabel',
    description: 'Learn more about creating and using GPG keys link',
    defaultMessage: 'Learn more about creating and using GPG keys',
  },
  helpDescriptionLearnTitle: {
    id: 'frontbucket.account.settings.gpgKeys.helpDescriptionLearnTitle',
    description:
      'Title message for the first paragraph on the help description',
    defaultMessage: "Don't have a key?",
  },
  helpDescriptionLearn: {
    id: 'frontbucket.account.settings.gpgKeys.helpDescriptionLearn',
    description:
      'Description message for the first paragraph on the help description that has external link',
    defaultMessage: 'Learn {link}.',
  },
  helpDescriptionLearnLink: {
    id: 'frontbucket.account.settings.gpgKeys.helpDescriptionLearnLink',
    description:
      'Link name (link) that leads to the guide how to generate GPG key and is being used in this text: Learn how to {link}.',
    defaultMessage: 'how to generate a GPG key',
  },
  helpDescriptionAlreadyHaveKeyTitle: {
    id: 'frontbucket.account.settings.gpgKeys.helpDescriptionAlreadyHaveKeyTitle',
    description:
      'Title message for the second paragraph on the help description',
    defaultMessage: 'Already have a key?',
  },
  helpDescriptionAlreadyHaveKey: {
    id: 'frontbucket.account.settings.gpgKeys.helpDescriptionAlreadyHaveKey',
    description:
      'Description message for the second paragraph on the help description that has example of console command',
    defaultMessage: 'Copy and paste your key with',
  },
  helpDescriptionProblemTitle: {
    id: 'frontbucket.account.settings.gpgKeys.helpDescriptionProblemTitle',
    description: 'Title message for the third paragraph the help description',
    defaultMessage: 'Problems adding a key?',
  },
  helpDescriptionProblem: {
    id: 'frontbucket.account.settings.gpgKeys.helpDescriptionProblem',
    description:
      'Description message for the third paragraph the help description that has external link',
    defaultMessage: 'Read our {link} for common issues.',
  },
  helpDescriptionProblemLink: {
    id: 'frontbucket.account.settings.gpgKeys.helpDescriptionProblemLink',
    description:
      'Link name (link) that leads to the troubleshooting page and is being used in this text: Read our {link} page for common issues.',
    defaultMessage: 'troubleshooting page',
  },
  modalFormFieldName: {
    id: 'frontbucket.account.settings.gpgKeys.create.modal.field.name',
    description: 'Text to display label for the GPG Key name',
    defaultMessage: 'Name',
  },
  validationErrorIsLong: {
    id: 'frontbucket.account.settings.gpgKeys.create.modal.field.validationErrorIsLong',
    description: 'Text to display validation error message when value too long',
    defaultMessage: '{fieldName} has a {maxLength} character maximum.',
  },
  modalFormFieldKey: {
    id: 'frontbucket.account.settings.gpgKeys.create.modal.field.key',
    description: 'Text to display label for the GPG Key',
    defaultMessage: 'GPG Public Key',
  },
  addKey: {
    id: 'frontbucket.account.settings.gpgKeys.addKey',
    description: 'Add key button name',
    defaultMessage: 'Add key',
  },
  addGpgKey: {
    id: 'frontbucket.account.settings.gpgKeys.modal.header.addGpgKey',
    description: 'Message for modal header during Create GPG key mode',
    defaultMessage: 'Add GPG key',
  },
  deleteModalDescriptionConfirmation: {
    id: 'frontbucket.account.settings.gpgKeys.create.modal.deleteModalDescriptionConfirmation',
    description:
      'Description confirmation message for the description on the delete modal',
    defaultMessage: 'Are you sure you want to delete this GPG key?',
  },
  deleteModalDescription: {
    id: 'frontbucket.account.settings.gpgKeys.create.modal.deleteModalDescription',
    description: 'Description message for the description on the delete modal',
    defaultMessage:
      'Once a GPG key has been deleted, any commits you sign with the deleted key moving forward will be unverified or rejected.',
  },
  deleteKey: {
    id: 'frontbucket.account.settings.gpgKeys.deleteKey',
    description: 'Delete key button name',
    defaultMessage: 'Delete',
  },
  deleteGpgKey: {
    id: 'frontbucket.account.settings.gpgKeys.modal.header.deleteGpgKey',
    description: 'Message for modal header during Delete GPG key mode',
    defaultMessage: 'Delete GPG key',
  },
  cancel: {
    id: 'frontbucket.account.settings.gpgKeys.cancel',
    description: 'Cancel button name',
    defaultMessage: 'Cancel',
  },
  close: {
    id: 'frontbucket.account.settings.gpgKeys.close',
    description: 'Close button name',
    defaultMessage: 'Close',
  },
  createSuccessNotificationText: {
    id: 'frontbucket.account.settings.gpgKeys.createSuccessNotificationText',
    description:
      'Text to be displayed inside success flag that appears after successful add GPG key',
    defaultMessage: 'Key successfully added',
  },
  deleteSuccessNotificationText: {
    id: 'frontbucket.account.settings.gpgKeys.deleteSuccessNotificationText',
    description:
      'Text to be displayed inside success flag that appears after successful delete GPG key',
    defaultMessage: 'Key successfully deleted',
  },
  gpgKeyIcon: {
    id: 'frontbucket.account.settings.gpgKeys.gpgKeyIcon',
    description: 'Icon text for GPG key icon',
    defaultMessage: 'GPG Key Icon',
  },
  gpgKeyEmailLabel: {
    id: 'frontbucket.account.settings.gpgKeys.gpgKeyEmailLabel',
    description: 'Label for Email',
    defaultMessage: 'Email',
  },
  gpgKeyLabel: {
    id: 'frontbucket.account.settings.gpgKeys.gpgKeyLabel',
    description: 'Label for Key',
    defaultMessage: 'Key',
  },
  gpgKeySubkeysLabel: {
    id: 'frontbucket.account.settings.gpgKeys.gpgKeySubkeysLabel',
    description: 'Label for Subkeys',
    defaultMessage: 'Subkeys',
  },
  gpgKeyExpLabel: {
    id: 'frontbucket.account.settings.gpgKeys.gpgKeyExpLabel',
    description: 'Label for Expiration date',
    defaultMessage: 'Exp',
  },
  gpgKeyDelete: {
    id: 'frontbucket.account.settings.gpgKeys.gpgKeyDelete',
    description: 'Text for delete button link',
    defaultMessage: 'Delete',
  },
  gpgKeyShow: {
    id: 'frontbucket.account.settings.gpgKeys.gpgKeyShow',
    description: 'Text for showing additional subkeys',
    defaultMessage: 'See all {total} subkeys',
  },
  gpgKeyHide: {
    id: 'frontbucket.account.settings.gpgKeys.gpgKeyHide',
    description: 'Text for hiding additional subkeys',
    defaultMessage: 'Hide keys',
  },
  verifiedLabel: {
    id: 'frontbucket.account.settings.gpgKeys.commitVerificationCard.verifiedLabel',
    description: 'Text to display that the key is an verified signature',
    defaultMessage: 'Verified signature',
  },
  unverifiedLabel: {
    id: 'frontbucket.account.settings.gpgKeys.commitVerificationCard.unverifiedLabel',
    description: 'Text to display that the key is an unverified signature',
    defaultMessage: 'Unverified signature',
  },
  notVerifiedTitle: {
    id: 'frontbucket.account.settings.gpgKeys.commitVerificationCard.notVerifiedTitle',
    description: 'Title to display that the key is not verified',
    defaultMessage: 'Not verified',
  },
  verifiedTitle: {
    id: 'frontbucket.account.settings.gpgKeys.commitVerificationCard.verifiedTitle',
    description: 'Title to display that the key is verified',
    defaultMessage: 'Verified',
  },
  verifiedSignedByText: {
    id: 'frontbucket.account.settings.gpgKeys.commitVerificationCard.verifiedSignedByText',
    description: 'Text to display who the key is signed by',
    defaultMessage: 'Signed by:',
  },
  gpgkey: {
    id: 'frontbucket.account.settings.gpgKeys.commitVerificationCard.gpgkey',
    description: 'Label for GPG key',
    defaultMessage: 'GPG key',
  },
  email: {
    id: 'frontbucket.account.settings.gpgKeys.commitVerificationCard.email',
    description: 'Label for email',
    defaultMessage: 'Email',
  },
  notVerifiedDescription: {
    id: 'frontbucket.account.settings.gpgKeys.commitVerificationCard.notVerifiedDescription',
    description: 'Text to describe that the key is not verified',
    defaultMessage: 'This commit was signed with an unverified signature.',
  },
  configureGpgKeysText: {
    id: 'frontbucket.account.settings.gpgKeys.commitVerificationCard.configureGpgKeysText',
    description: 'Text to configure GPG keys',
    defaultMessage: 'Configure GPG keys',
  },
  spotlightHeader: {
    id: 'frontbucket.account.settings.gpgKeys.spotlight.header',
    description: 'Header text for GPG Key Spotlight',
    defaultMessage: 'Introducing enforced signed commits',
  },
  spotlightBody: {
    id: 'frontbucket.account.settings.gpgKeys.spotlight.body',
    description: 'Body text for GPG Key Spotlight',
    defaultMessage: `As a Premium Bitbucket Cloud customer, workspace admins can now enforce signed commits across your team's workflow, which means commits must be signed using a GPG key. If enforced signed commits is enabled, add a GPG key to continue collaborating on code with your team.`,
  },
  spotlightDismiss: {
    id: 'frontbucket.account.settings.gpgKeys.spotlight.dismiss',
    description: 'Dismiss text for GPG Key Spotlight',
    defaultMessage: 'Dismiss',
  },
});
